import { render, staticRenderFns } from "./remoteCopy.vue?vue&type=template&id=149e1212&scoped=true&"
import script from "./remoteCopy.vue?vue&type=script&lang=js&"
export * from "./remoteCopy.vue?vue&type=script&lang=js&"
import style0 from "./remoteCopy.vue?vue&type=style&index=0&id=149e1212&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "149e1212",
  null
  
)

export default component.exports